import { makeServiceRequest } from 'owa-service/lib/ServiceRequest';
import type RequestOptions from 'owa-service/lib/RequestOptions';
import type OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';

interface OwaUserConfigurationResponse {
    userConfig: OwaUserConfiguration;
    headers: Headers;
}
export default function getOwaUserConfigurationHeadersOperation(
    options: RequestOptions
): Promise<OwaUserConfigurationResponse> {
    options.returnResponseHeaders = true;
    return makeServiceRequest<Response>('GetOwaUserConfiguration', {}, options)
        .then(async (response: Response) => {
            const responseBody = await response.json();
            return { userConfig: responseBody, headers: response.headers };
        })
        .catch(err => {
            throw new Error('getOwaUserConfiguration for connected account failed');
        });
}
